<template>
  <div class="tdt-map" ref="map" style="width: 100%; height: 500px"></div>
</template>

<script>
import loadTDT from "@/utils/loadTDT.js";

export default {
  name: "TdtMap",
  props: {
    tk: { type: String, required: true },
    center: {
      type: Array,
      default: () => [116.40769, 39.89945], // 北京
    },
    zoom: { type: Number, default: 15 },
    // 标记点数组
    markers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      map: null,
      T: null,
      markerList: [],   
    };
  },
  async mounted() {
    const T = await loadTDT(this.tk);
    this.T = T;

    this.$nextTick(() => {
      this.initMap();
    });
  },
  methods: {
    initMap() {
      const T = this.T;
      if (!T) return;

      this.map = new T.Map(this.$refs.map, { projection: "EPSG:3857" });

      const center = new T.LngLat(this.center[0], this.center[1]);
      this.map.centerAndZoom(center, this.zoom);
      this.map.enableScrollWheelZoom();

      // 有初始 markers 的情况
      if (this.markers && this.markers.length) {
        this.addMarkers();
      }

      this.map.addControl(new T.Control.Scale());
      this.map.addControl(new T.Control.Zoom());

      this.map.addEventListener("click", (e) => {
        const { lng, lat } = e.lnglat;
        this.$emit("map-click", { lng, lat });
      });
    },

    // 添加 / 更新标记点
    addMarkers() {
      const T = this.T;
      if (!T || !this.map) return;

      // 1. 先清理旧的覆盖物
      this.markerList.forEach((m) => this.map.removeOverLay(m));
      this.markerList = [];

      // 2. 重新根据 this.markers 画点
      if (!this.markers || !this.markers.length) return;

      this.markers.forEach((item, index) => {
        const point = new T.LngLat(item.lng, item.lat);

        // 设置自定义图标
        let markerOpts = {};
        if (item.icon) {
          const icon = new T.Icon({
            iconUrl: item.icon,
            iconSize: new T.Point(32, 32),
            iconAnchor: new T.Point(16, 32),
          });
          markerOpts.icon = icon;
        }

        const marker = new T.Marker(point, markerOpts);
        this.map.addOverLay(marker);
        this.markerList.push(marker);

        // 如果需要地图跟着移动到新点，可以打开下面这一行：
        if (index === 0) this.map.panTo(point);
      });
    },
  },
  watch: {
    // 监听父组件传入的 markers 变化，重新绘制
    markers: {
      handler() {
        // 地图尚未初始化时，不处理，等 mounted/initMap 后再统一画一次
        if (!this.map || !this.T) return;
        this.addMarkers();
      },
      deep: true,
      immediate: true, // 父组件一进来就会根据初始 markers 画一次
    },
  },
};
</script>
